import { render, staticRenderFns } from "./ArcYieldWalletInput.vue?vue&type=template&id=18d44a8e&"
import script from "./ArcYieldWalletInput.vue?vue&type=script&lang=ts&"
export * from "./ArcYieldWalletInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports